import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ce324e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pricetable__header" }
const _hoisted_2 = { class: "pricetable__header_item" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pricetable__header_title" }, [
  /*#__PURE__*/_createTextVNode(" Volwassene "),
  /*#__PURE__*/_createElementVNode("span", { class: "pricetable__header_age" }, "17+")
], -1))
const _hoisted_4 = { class: "pricetable__header_item" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pricetable__header_title" }, [
  /*#__PURE__*/_createTextVNode(" Student "),
  /*#__PURE__*/_createElementVNode("span", { class: "pricetable__header_age" }, "18+"),
  /*#__PURE__*/_createElementVNode("span", { class: "pricetable__header_note" }, "(CJP of studentenkaart)")
], -1))
const _hoisted_6 = { class: "pricetable__header_item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pricetable__header_title" }, [
  /*#__PURE__*/_createTextVNode(" Kind "),
  /*#__PURE__*/_createElementVNode("span", { class: "pricetable__header_age" }, "t/m 17 jaar")
], -1))
const _hoisted_8 = { class: "pricetable__main" }
const _hoisted_9 = { class: "pricetable__item" }
const _hoisted_10 = { class: "pricetable__item__name" }
const _hoisted_11 = ["aria-expanded", "aria-controls", "onClick"]
const _hoisted_12 = {
  key: 0,
  class: "pricetable__item__description"
}
const _hoisted_13 = { class: "pricetable__prices" }
const _hoisted_14 = ["id"]
const _hoisted_15 = { class: "pricetable__extra-inner" }
const _hoisted_16 = { class: "pricetable__extra-text" }
const _hoisted_17 = { class: "pricetable__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Illustration = _resolveComponent("Illustration")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_ButtonLink = _resolveComponent("ButtonLink")!
  const _directive_sanitize = _resolveDirective("sanitize")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["pricetable", { 'pricetable--sidebar': _ctx.sidebarMode }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Illustration, { class: "pricetable__header_illustration" }),
        _hoisted_3
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Illustration, {
          type: "student",
          class: "pricetable__header_illustration"
        }),
        _hoisted_5
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_Illustration, {
          type: "kind",
          class: "pricetable__header_illustration"
        }),
        _hoisted_7
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.prices, (pricerow, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["pricetable__row", { 'pricetable__row--open': _ctx.openRows[index] }]),
        key: `pricerow-${pricerow.name}`
      }, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", null, _toDisplayString(pricerow.name), 1),
              (_ctx.hasExtraInfo(pricerow))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "pricetable__info",
                    "aria-expanded": _ctx.openRows[index] ? 'true' : 'false',
                    "aria-controls": `pricetable-extra-${index}`,
                    "aria-label": "Extra informatie",
                    onClick: ($event: any) => (_ctx.toggleInfo(index))
                  }, [
                    _createVNode(_component_Icon, { type: "info" })
                  ], 8, _hoisted_11))
                : _createCommentVNode("", true)
            ]),
            (pricerow.description)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(pricerow.description), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pricerow.prices, (price, priceIndex) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "pricetable__price",
                key: `price-${priceIndex}`
              }, _toDisplayString(price), 1))
            }), 128))
          ])
        ]),
        (_ctx.hasExtraInfo(pricerow))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "pricetable__extra",
              id: `pricetable-extra-${index}`
            }, [
              _createElementVNode("div", _hoisted_15, [
                _withDirectives(_createElementVNode("div", _hoisted_16, null, 512), [
                  [_directive_sanitize, pricerow.extraInfo]
                ])
              ])
            ], 8, _hoisted_14))
          : _createCommentVNode("", true)
      ], 2))
    }), 128)),
    _createElementVNode("div", _hoisted_17, [
      _createVNode(_component_ButtonLink, {
        href: "https://tickets.nederlandsmijnmuseum.nl",
        target: "_blank",
        label: "Bestel tickets",
        color: _ctx.sidebarMode ? 'yellow' : null,
        fontweight: _ctx.sidebarMode ? 'regular' : ''
      }, null, 8, ["color", "fontweight"])
    ])
  ], 2))
}